module.exports = __webpack_public_path__ + "579e340a4fb4f753494fc8512232158d.png";